import { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openFaqDialog } from '../actions/faqDialog';
import { openDownloadDialog } from '../actions/downloadDialog';
import DataContext from '../context';
import { CLIENT_PATH } from '../constants';
import getURL from '../utils/getURL';

import Button from './Button';

import styles from './Aside.module.css';

const Aside = () => {
    const { data, selectedTerm } = useContext(DataContext);
    const timetable = useSelector(state => state.app.timetable);
    const [showLinkInput, setShowLinkInput] = useState(false);
    const [copyResult, setCopyResult] = useState("");
    const [shareURL, setShareURL] = useState("");
    const shareInputRef = useRef();
    const dispatch = useDispatch();

    const handleShareButtonClick = () => {
        if (!data || !selectedTerm) {
            setCopyResult('Please select a term first.');
            return;
        }

        setShowLinkInput(true);

        // Build share URL using current location origin
        const baseUrl = window.location.origin + (CLIENT_PATH || '/');
        const urlParams = getURL(selectedTerm, timetable);
        const newURL = `${baseUrl.replace(/\/$/, '')}/${urlParams}`;

        setShareURL(newURL);

        if (!navigator.clipboard) {
            setCopyResult('Select the link and copy it manually.');
            return;
        }
        navigator.clipboard.writeText(newURL).then(
            () => {
                setCopyResult('Copied to the clipboard automatically.');
            },
            () => {
                setCopyResult('Select the link and copy it manually.');
            },
        );
    };

    useEffect(() => {
        if (showLinkInput) shareInputRef.current?.select();
    }, [showLinkInput, shareURL]);

    return (
        <div className={styles.aside}>
            <div>
                {showLinkInput && (
                    <div className={styles.shareLinkInputContainer}>
                        <input
                            className={styles.shareLinkInput}
                            type="text"
                            value={shareURL}
                            ref={shareInputRef}
                            readOnly
                            aria-label="Share link"
                        />
                    </div>
                )}
                <div className={styles.copyResult} id="copyResult" role="status" aria-live="polite">
                    {copyResult}
                </div>
                <div className={styles.buttonSet}>
                    <div className={styles.buttonContainer}>
                        <Button
                            className={styles.shareButton}
                            onClick={handleShareButtonClick}
                        >
                            Get Share Link
                        </Button>
                    </div>
                    <div className={styles.buttonContainer}>
                        <Button
                            className={styles.faqButton}
                            onClick={() => dispatch(openFaqDialog)}
                        >
                            Show FAQ
                        </Button>
                    </div>
                    <div className={styles.buttonContainer}>
                        <Button
                            className={styles.downloadButton}
                            onClick={() => dispatch(openDownloadDialog)}
                        >
                            Download Plan
                        </Button>
                    </div>
                </div>
            </div>
            <div>
                <p className={styles.lastUpdate}>
                    {`Data last updated: `}
                    <br />
                    {data?.lastUpdated || ''}
                </p>
            </div>
        </div>
    );
};

export default Aside;
